import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    headerContainer: {
        flexDirection: "row",
        alignContent: "center",
        alignItems: "center",
        justifyContent:"space-between"
    },
    headerGoBack: {
        alignSelf: "flex-start"
    },
    headerTitle: {
        position: "absolute",
        left: 0,
        right: 0
    },
    tabBarSwitchContainer: {
        flexDirection: "row"
    },
    tabBarButtonContainer: {
        flexDirection: "row",
        alignContent: "center",
        alignItems: "center",
        alignSelf: "baseline"
    },
    tabBarContentLength: {
        alignContent: "center",
        alignItems: "center"
    },
    createCompany: {
        flex: 1,
        alignSelf: "center"
    },
    editSheetHeader: {
        alignItems: "center"
    },
    editSheetButton: {
        flexDirection: "row",
        alignItems: "center"
    },
    deleteDialogHeaderContainer: {
        alignContent: "center",
        alignItems: "center",
        justifyContent: "center"
    },
    headerTitleText: {
        alignSelf: "center"
    },
    companyLogo: {
        width: 60,
        height: 60
    },
    createCompanyButton: {
        alignSelf: "center"
    },
    dialogIconContainer: {
        alignSelf: "center"
    },
    dialogTitle: {
        textAlign: "center"
    }
});
export default stylesheet;
